export default "__VITE_ASSET__70df0414__"